<script lang="ts">
	import type { ISbStoryData, StoryblokComponentType } from '@storyblok/js';
	import type { SbImageFormat, SbVideo } from '../types';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import type { ImageBlock } from './imageBlock.svelte';

	interface Props {
		content: ISbStoryData<{
			aspect_ratio: Extract<SbImageFormat, '3/4' | '4/3'>;
			asset: Array<ISbStoryData<ImageBlock | SbVideo>['content']>;
			text?: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="slide relative aspect-3/4 lg:aspect-{content.aspect_ratio} flex-none overflow-hidden rounded-2xl max-lg:max-w-[80vw] lg:h-[55vh]"
>
	{#if content.asset.length > 0}
		<Blok content={content.asset[0]} />
	{/if}
	{#if content.text && content.text.length > 0}
		<p
			class="absolute inset-x-0 bottom-0 flex select-none items-end p-5 text-[24px]/[108%] tracking-[-.24px] text-white lg:p-6 lg:text-[32px]/[110%] lg:tracking-[.32px]"
		>
			{content.text}
		</p>
	{/if}
</div>
